// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Leadership_main_container{
    height: 860px;
    background-color: #012D01;
    padding: 0 50px;
}

.Leadership_card_container{
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    justify-content: center;
}

.Leadership_card{
    width: 400px;
    height: 170px;
    border-radius: 20px;
    border: 1px solid rgba(92, 191, 20, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.Leadership_card_text1{
    font-size: 25px;
    font-weight: 700;
    line-height: 38px;
}

.leadership_card_hr{
    width: 239px;
    border: 1px solid #7A7A7A;
    margin: 20px 0;

}

.Leadership_card_text2{
    font-size: 20px;
    font-weight: 400;
    line-height: 31px;
    color:#EAAD11;
    text-align: center;
    padding: 0 20px;
}

/* responsiveness starts here */

@media screen and (max-width: 1050px){
    .Leadership_main_container{
        padding: 0 40px;
    }

    .Leadership_card{
        width: 295px;
    }

    .Leadership_card_text1{
        font-size: 19px;
    }
    
    .leadership_card_hr{
        width: 230px;
    
    }
    
    .Leadership_card_text2{
        font-size: 16px;
    
    }
}

@media screen and (max-width: 900px){
    .Leadership_main_container{
        height: 1200px;
        padding: 0 30px ;
        
    }

    .Leadership_card{
        width: 330px;
    }

    .Leadership_card_text1{
        font-size: 18px;
    }
    
    .leadership_card_hr{
        width: 230px;
    
    }
    
    .Leadership_card_text2{
        font-size: 15px;
    
    }
}

@media screen and (max-width: 500px){
    .Leadership_main_container{
        height: 2130px;
        background-color: #012D01;
        padding: 0 50px;
    }
    
    .Leadership_card_container{
        display: flex;
        flex-direction: column;
        flex-flow: row wrap;
        gap: 20px;
    }
    
    .Leadership_card{
        width: 100%;
        height: 170px;
        border-radius: 20px;
        border: 1px solid rgba(92, 191, 20, 0.4);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    
    .Leadership_card_text1{
        font-size: 19px;
        font-weight: 700;
        line-height: 30.58px;
    }
    
    .leadership_card_hr{
        width: 239px;
        border: 1px solid #7A7A7A;
        margin: 20px 0;
    
    }
    
    .Leadership_card_text2{
        font-size: 15px;
        font-weight: 400;
        line-height: 24.46px;
        color:#EAAD11;
    }
}

@media screen and (max-width: 400px){
    
    .Leadership_card_text1{
        font-size: 18px;
    }

    .leadership_card_hr{
        width: 220px;
    
    }
    
    .Leadership_card_text2{
        font-size: 14px;
    }
}

@media screen and (max-width: 330px){
    
    .Leadership_card_text1{
        font-size: 14px;
    }

    .leadership_card_hr{
        width: 180px;
    
    }
    
    .Leadership_card_text2{
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Leadership.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA,+BAA+B;;AAE/B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;;IAEnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;;IAEpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;;IAEnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,wCAAwC;QACxC,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,cAAc;;IAElB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".Leadership_main_container{\n    height: 860px;\n    background-color: #012D01;\n    padding: 0 50px;\n}\n\n.Leadership_card_container{\n    display: flex;\n    flex-flow: row wrap;\n    gap: 20px;\n    justify-content: center;\n}\n\n.Leadership_card{\n    width: 400px;\n    height: 170px;\n    border-radius: 20px;\n    border: 1px solid rgba(92, 191, 20, 0.4);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.Leadership_card_text1{\n    font-size: 25px;\n    font-weight: 700;\n    line-height: 38px;\n}\n\n.leadership_card_hr{\n    width: 239px;\n    border: 1px solid #7A7A7A;\n    margin: 20px 0;\n\n}\n\n.Leadership_card_text2{\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 31px;\n    color:#EAAD11;\n    text-align: center;\n    padding: 0 20px;\n}\n\n/* responsiveness starts here */\n\n@media screen and (max-width: 1050px){\n    .Leadership_main_container{\n        padding: 0 40px;\n    }\n\n    .Leadership_card{\n        width: 295px;\n    }\n\n    .Leadership_card_text1{\n        font-size: 19px;\n    }\n    \n    .leadership_card_hr{\n        width: 230px;\n    \n    }\n    \n    .Leadership_card_text2{\n        font-size: 16px;\n    \n    }\n}\n\n@media screen and (max-width: 900px){\n    .Leadership_main_container{\n        height: 1200px;\n        padding: 0 30px ;\n        \n    }\n\n    .Leadership_card{\n        width: 330px;\n    }\n\n    .Leadership_card_text1{\n        font-size: 18px;\n    }\n    \n    .leadership_card_hr{\n        width: 230px;\n    \n    }\n    \n    .Leadership_card_text2{\n        font-size: 15px;\n    \n    }\n}\n\n@media screen and (max-width: 500px){\n    .Leadership_main_container{\n        height: 2130px;\n        background-color: #012D01;\n        padding: 0 50px;\n    }\n    \n    .Leadership_card_container{\n        display: flex;\n        flex-direction: column;\n        flex-flow: row wrap;\n        gap: 20px;\n    }\n    \n    .Leadership_card{\n        width: 100%;\n        height: 170px;\n        border-radius: 20px;\n        border: 1px solid rgba(92, 191, 20, 0.4);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    \n    .Leadership_card_text1{\n        font-size: 19px;\n        font-weight: 700;\n        line-height: 30.58px;\n    }\n    \n    .leadership_card_hr{\n        width: 239px;\n        border: 1px solid #7A7A7A;\n        margin: 20px 0;\n    \n    }\n    \n    .Leadership_card_text2{\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 24.46px;\n        color:#EAAD11;\n    }\n}\n\n@media screen and (max-width: 400px){\n    \n    .Leadership_card_text1{\n        font-size: 18px;\n    }\n\n    .leadership_card_hr{\n        width: 220px;\n    \n    }\n    \n    .Leadership_card_text2{\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width: 330px){\n    \n    .Leadership_card_text1{\n        font-size: 14px;\n    }\n\n    .leadership_card_hr{\n        width: 180px;\n    \n    }\n    \n    .Leadership_card_text2{\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
